import styles from './Document.module.css';
import { FormattedDate } from 'react-intl';

export const Document = ({ document }) => (
    <div className={styles.Document}>
        <div>{document.attributes.document_name}</div>
        <div>
            <FormattedDate
                value={new Date(document.attributes.uploaded_at)}
                day="2-digit"
                month="short"
                year="numeric"
            />
        </div>
    </div>
);
